import React, { useEffect, useState } from "react";
import dobropostLogoBlackStroke from "../../shared/assets/images/dobropostLogoBlackStoke.webp";

// import { ACCORDIONS_DATA } from "../../shared/constants/parcels";
// import EmailIcon from "../../shared/iconComponents/EmailIcon";
// import InstagramIcon from "../../shared/iconComponents/InstagramIcon";
// import TelegramIconBlackStroke from "../../shared/iconComponents/TelegramIconBlackStroke";
// import VkIconBlackStroke from "../../shared/iconComponents/VkIconBlackStroke";
// import PhoneIcon from "../../shared/iconComponents/PhoneIcon";
import {
  BASE_URL_PARCEL,
  SHIPMENT_BASE_URL,
  // INSTAGRAM_DOBROPOST_URL,
  // TELEGRAM_DOBROPOST_URL,
  // VK_DOBROPOST_URL,
} from "../../shared/constants";
import { isParcelTrackingCode } from "../../shared/utils";
import { Button, Link, Snackbar } from "@mui/material";
import styles from "./styles.module.scss";
// import MaterialAccordion from "../MaterialAccordion";
// import LanguageSelectView from "../LanguageSelectView";
import TrackingSection from "../TrackingSection";
import useRouter from "../../shared/hooks/useRouter";

const ParcelTracking = () => {
  const [trackingNumber, setTrackingNumber] = useState("");
  const [responseData, setResponseData] = useState(null);
  const [loading, setLoading] = useState(false);
  const { query } = useRouter();

  const [error, setError] = useState(null);

  const fetchTrackingData = async (url) => {
    setLoading(true);
    setError(null);
    try {
      const response = await fetch(url);
      const result = await response.json();

      if (response.ok) {
        setResponseData(result);
      } else if (response.status === 404) {
        const type = isParcelTrackingCode(trackingNumber) ? "Посылка" : "Шипмент";
        setError(`${type} с кодом ${trackingNumber} не найден(а)`);
      } else if (response.status === 500) {
        setError("Ошибка, попробуйте пожалуйста позже");
      } else {
        setError(result.message || "Something went wrong");
      }
      return result;
    } catch (error) {
      const errorMessage = error.message ? error.message : error;
      setError(errorMessage || "Something went wrong");
    } finally {
      setLoading(false);
    }
  };

  const handleTrackingSubmit = (e) => {
    e.preventDefault();
    if (!trackingNumber) return;
    const url = isParcelTrackingCode(trackingNumber)
      ? BASE_URL_PARCEL
      : SHIPMENT_BASE_URL;
    fetchTrackingData(`${url}&trackCode=${trackingNumber}`);
  };

  useEffect(() => {
    if (query.trackNumber) {
      setTrackingNumber(query.trackNumber);
      const url = isParcelTrackingCode(query.trackNumber)
        ? BASE_URL_PARCEL
        : SHIPMENT_BASE_URL;
      fetchTrackingData(`${url}&trackCode=${query.trackNumber}`);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [query.trackNumber]);

  return (
    <div className={styles.container}>
      <header className={styles.header}>
        <Link href="/">
          <img
            src={dobropostLogoBlackStroke}
            alt="DobroPost"
            className={styles.logo}
          />
        </Link>
        {/* <LanguageSelectView /> */}
      </header>

      <h1 className={styles.title}>Отследить посылку</h1>
      <main className={styles.mainContent}>
        <form onSubmit={handleTrackingSubmit} className={styles.form}>
          <input
            name="trackingNumber"
            placeholder="Введите номер заказа"
            value={trackingNumber}
            onChange={(e) => {
              setTrackingNumber(e.target.value);
              setResponseData(null);
              setError(null);
            }}
            className={styles.input}
          />
          <button type="submit" className={styles.button}>
            Отследить
          </button>
        </form>

        {!loading && responseData ? (
          <TrackingSection
            responseData={responseData}
            trackingNumber={trackingNumber}
          />
        ) : (
          <section className={styles.howToUse}>
            <h2>Как воспользоваться?</h2>
            <p>
              Здесь вы можете отследить местонахождение вашей посылки. Для этого
              введите номер посылки (формат DBRPST0000000000) в поле для ввода и
              нажмите кнопку &quot;Отследить&quot;.
            </p>
          </section>
        )}

        {/* <section className={styles.faqSection}>
          <h2>Частые вопросы</h2>
          <MaterialAccordion styles={styles} accordions={ACCORDIONS_DATA} />
        </section> */}
      </main>

      {/* <aside className={styles.helpSection}>
        <div className={styles.helpSectionContent}>
          <h2>Нужна помощь?</h2>
          <p>
            Если что-то пошло не так, свяжитесь с нашей службой поддержки
            удобным для вас способом.
          </p>
        </div>
        <div className={styles.helpSectionSocials}>
          <h2>Написать в чат</h2>
          <div className={styles.socialIcons}>
            <a
              href={INSTAGRAM_DOBROPOST_URL}
              target="_blank"
              rel="noreferrer"
              aria-label="Instagram Icon"
            >
              <InstagramIcon />
            </a>
            <a
              href={TELEGRAM_DOBROPOST_URL}
              target="_blank"
              rel="noreferrer"
              aria-label="Telegram Icon"
            >
              <TelegramIconBlackStroke />
            </a>
            <a
              href={VK_DOBROPOST_URL}
              target="_blank"
              rel="noreferrer"
              aria-label="Vk Icon"
            >
              <VkIconBlackStroke />
            </a>
          </div>
        </div>
        <div className={styles.helpSectionContacts}>
          <div className={styles.contactItem}>
            <EmailIcon className={styles.emailIcon} />
            <a
              href="mailto:support@dobropost.com"
              className={styles.contactLink}
            >
              support@dobropost.com
            </a>
          </div>
          <div className={styles.contactItem}>
            <PhoneIcon className={styles.phoneIcon} />
            <a href="tel:88006003794" className={styles.contactLink}>
              8 800 600 37 94
            </a>
          </div>
        </div>
      </aside> */}
      {error && (
        <Snackbar
          open={!!error}
          autoHideDuration={3000}
          message={error ? error : "Something went wrong"}
          anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
          ContentProps={{
            className: styles.errorSnackbar,
          }}
          action={
            <React.Fragment>
              <Button
                color="primary"
                size="small"
                onClick={() => setError(null)}
              >
                Отменить
              </Button>
            </React.Fragment>
          }
        />
      )}
    </div>
  );
};

export default ParcelTracking;
